import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
declare var $: any;
@Component({
  selector: 'app-dynamic-section-list',
  templateUrl: './dynamic-section-list.component.html',
  styleUrls: ['./dynamic-section-list.component.css']
})
export class DynamicSectionListComponent implements OnInit {
  List = [];
  show_multiple_delete_btn = false;
  NewsDeleteCheckboxList = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) {
    this.DefaultComponent.loaderShow();
    this.get_list();
  }
  get_list() {
    this.CommonService.getDynamicSectionList().subscribe((data) => {
      if (data.status) {
        this.List = data.news_list;
      } else {
        if (data.token_expire) {
          localStorage.removeItem('login_token');
          this.router.navigate(['/']);
        }
      }
      this.DefaultComponent.loaderHide();
    });
  }
  toggleVisibility(e, type) {
    var th = this;
    if (e.target.checked == true) {
      var cat_id = e.target.value;
      var status = 'yes';
    } else {
      var cat_id = e.target.value;
      var status = 'no';
    }
    this.DefaultComponent.loaderShow();
    var token = localStorage.getItem('login_token');
    var routers = this.router;
    $.ajax({
      url: environment.DynamicSectionBaseUrl + 'section_status_change',
      method: 'POST',
      data: { cat_id: cat_id, status: status, type: type },
      headers: {
        'Authorization': token
      },
      dataType: 'json',
      success: function (res) {
        th.DefaultComponent.loaderHide();
        if (res.status) {
          th.toastr.success(res.message)
          th.get_list();
        } else {
          if (res.token_expire) {
            localStorage.removeItem('login_token');
            routers.navigate(['/']);
          }
          else {
            th.toastr.error(res.message)
          }
        }
        $('.btn-success').attr('disabled', false);
      }
    });
  }
  update_display_orders(e, id, ori_ord, type) {
    if (parseInt(ori_ord) != parseInt(e.target.value)) {
      var th = this;
      var routers = this.router;
      this.DefaultComponent.loaderShow();
      var parameter = { 'display_order': e.target.value, 'id': id, 'ori_display_order': ori_ord, 'table_name': 'tbl_epaper_category', type: type };
      this.CommonService.UpdateSectionDisplayOrder(parameter).subscribe((data) => {
        if (data.status) {
          th.toastr.success(data.message);
          th.get_list();
        } else {
          if (data.token_expire) {
            localStorage.removeItem('login_token');
            routers.navigate(['/']);
          } else {
            th.toastr.error(data.message);
          }
        }
        this.DefaultComponent.loaderHide();
      });
    }
  }
  ngOnInit(): void {
  }
}
